module.exports = __webpack_public_path__ + "img/Lunghezza180_ok.679a2a84.png";